import React, { Component } from 'react';
import './Button.css';

class Button extends Component {
  render() {
    let { children, className, style, onClick } = this.props;
    className = "" || className;
    return (
      <button className={"Button " + className} onClick={onClick} style={style}>
        {children}
      </button>
    );
  }
}

export default Button;



/** WEBPACK FOOTER **
 ** ./src/components/Button/index.js
 **/